/* components/patterns/LanguagePicker.jsx — модалка выбора языка с поиском (S12, фикс №20).
   Делает футер-кнопку языка живой: открывает поиск по списку языков (нативное имя + en + код).
   Собрана на UI-ките: Modal (хром/focus-trap/scroll-lock/Esc/backdrop) + SearchInput.
   ХЕНДОФФ → frontend/src/components/common/LanguagePicker.jsx (там — отдельная реализация). */

import React from 'react';
import { Modal } from '../ui/Modal.jsx';
import { SearchInput } from '../ui/Field.jsx';
import { Icon } from '../ui/Icon.jsx';

  const { useMemo, useState } = React;

  const LANGUAGES = [
    { code: 'ru', native: 'Русский', en: 'Russian' },
    { code: 'en', native: 'English', en: 'English' },
    { code: 'uk', native: 'Українська', en: 'Ukrainian' },
    { code: 'es', native: 'Español', en: 'Spanish' },
    { code: 'fr', native: 'Français', en: 'French' },
    { code: 'de', native: 'Deutsch', en: 'German' },
    { code: 'it', native: 'Italiano', en: 'Italian' },
    { code: 'pt', native: 'Português', en: 'Portuguese' },
    { code: 'pl', native: 'Polski', en: 'Polish' },
    { code: 'tr', native: 'Türkçe', en: 'Turkish' },
    { code: 'nl', native: 'Nederlands', en: 'Dutch' },
    { code: 'sv', native: 'Svenska', en: 'Swedish' },
    { code: 'no', native: 'Norsk', en: 'Norwegian' },
    { code: 'fi', native: 'Suomi', en: 'Finnish' },
    { code: 'cs', native: 'Čeština', en: 'Czech' },
    { code: 'el', native: 'Ελληνικά', en: 'Greek' },
    { code: 'zh', native: '中文 (简体)', en: 'Chinese (Simplified)' },
    { code: 'ja', native: '日本語', en: 'Japanese' },
    { code: 'ko', native: '한국어', en: 'Korean' },
    { code: 'ar', native: 'العربية', en: 'Arabic' },
    { code: 'he', native: 'עברית', en: 'Hebrew' },
    { code: 'hi', native: 'हिन्दी', en: 'Hindi' },
    { code: 'th', native: 'ไทย', en: 'Thai' },
    { code: 'vi', native: 'Tiếng Việt', en: 'Vietnamese' },
    { code: 'id', native: 'Bahasa Indonesia', en: 'Indonesian' },
    { code: 'ka', native: 'ქართული', en: 'Georgian' },
  ];

  const LANG_NATIVE = Object.fromEntries(LANGUAGES.map((l) => [l.code, l.native]));

  function LanguagePicker({ value = 'ru', onSelect, onClose }) {
    const [q, setQ] = useState('');

    const filtered = useMemo(() => {
      const s = q.trim().toLowerCase();
      if (!s) return LANGUAGES;
      return LANGUAGES.filter(
        (l) => l.native.toLowerCase().includes(s)
          || l.en.toLowerCase().includes(s)
          || l.code.includes(s),
      );
    }, [q]);

    return (
      <Modal open onClose={onClose} title="Выберите язык" size="sm"
             labelledBy="lang-picker-title" autoFocusSelector=".search-input input"
             className="lang-picker">
        <div className="lang-picker__search">
          <SearchInput value={q} onChange={setQ} placeholder="Поиск языка" autoComplete="off" spellCheck="false" />
        </div>
        <div className="lang-picker__list" role="listbox" aria-label="Языки">
          {filtered.length === 0 ? (
            <div className="lang-picker__empty t-body text-mute">Ничего не найдено</div>
          ) : filtered.map((l) => {
            const active = l.code === value;
            return (
              <button
                key={l.code}
                type="button"
                role="option"
                aria-selected={active}
                className={'lang-picker__row' + (active ? ' is-active' : '')}
                onClick={() => onSelect && onSelect(l.code)}
              >
                <span className="lang-picker__row-text">
                  <span className="lang-picker__row-native">{l.native}</span>
                  <span className="lang-picker__row-en">{l.en}</span>
                </span>
                <span className="lang-picker__row-code num">{l.code.toUpperCase()}</span>
                {active && <Icon name="check" size={15} className="lang-picker__row-check" />}
              </button>
            );
          })}
        </div>
      </Modal>
    );
  }

export { LanguagePicker, LANGUAGES, LANG_NATIVE };
